import React, { useContext } from "react";
import { RicosViewerContext } from "./../../../../../ricos-context";
import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import {
  addAnchorTagToUrl,
  anchorScroll,
  convertRelObjectToString,
  normalizeHref
} from "./../../../../../wix-rich-content-common";
import classes from "./link-viewer-wrapper.rtlignore-scss";
const LinkViewerWrapper = ({
  children,
  nodeType,
  link
}) => {
  const { anchorTarget, customAnchorScroll } = useContext(RicosViewerContext);
  if (!(link && nodeType !== Node_Type.BUTTON)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  const urlHref = link?.url && normalizeHref(link.url);
  const viewerAnchorHref = link?.anchor ? `#viewer-${link?.anchor}` : void 0;
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: link ? classes.anchor : void 0,
      href: urlHref ?? viewerAnchorHref,
      target: link.target ? `_${link.target.toLowerCase()}` : anchorTarget,
      rel: link.rel && convertRelObjectToString(link.rel),
      onClick: link?.anchor ? (e) => {
        if (customAnchorScroll) {
          return customAnchorScroll(e, link?.anchor);
        }
        const anchorRefId = `viewer-${link?.anchor}`;
        const element = document.getElementById(anchorRefId);
        if (!element) {
          return;
        }
        addAnchorTagToUrl(anchorRefId);
        anchorScroll(element);
      } : void 0
    },
    children
  );
};
export {
  LinkViewerWrapper
};
//# sourceMappingURL=LinkViewerWrapper.js.map
